module.exports = __webpack_public_path__ + "static/assets/fba44573f183ea4443c04c4e28fe1728.png";